import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";

export default function ConsumerPriceIndex({ year }) {
  const [cpi, setCpi] = useState([]);
  const [months, setMonths] = useState([]);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    setLoading(true);
    async function getDocuments() {
      const q = query(
        collection(db, "consumer-price-index"),
        where("country", "==", "Kenya"),
        where("year", "==", year)
      );
      const allDocs = [];
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        allDocs.push(doc.data());
      });

      allDocs.sort((a, b) => {
        return a["index"] - b["index"];
      });

      const allMonths = [];
      const allCpi = [];

      allDocs.forEach((e) => {
        allMonths.push(e["month"]);
        allCpi.push(e["cpi"]);
      });
      setCpi(allCpi);
      setMonths(allMonths);
      setLoading(false);
    }
    getDocuments();
  }, [year]);

  return loading ? (
    <h1>Loading</h1>
  ) : (
    <>
      {cpi.length > 0 ? (
        <ReactApexChart
          options={{
            theme: {
              mode: "dark",
            },
            title: {
              text: `Consumer Price Index (${year})`,
              align: "center",
              style: {
                fontSize: "20px",
              },
            },
            chart: {
              type: "area",
              height: 400,
              zoom: {
                enabled: false,
              },
            },
            stroke: {
              curve: "smooth",
            },
            fill: {
              type: "gradient",
              gradient: {
                shade: "dark",
                gradientToColors: ["rgba(27,27,251,1)"],
                shadeIntensity: 1,
                type: "vertical",
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100],
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
              },
            },
            dataLabels: {
              enabled: false,
              formatter: function (value) {
                return value;
              },
            },
            yaxis: {
              labels: {
                formatter: function (value) {
                  return value;
                },
              },
            },
            xaxis: {
              categories: months,
            },
          }}
          series={[
            {
              name: "CPI",
              data: cpi,
            },
          ]}
          height={400}
          type="area"
        />
      ) : (
        <h1>No data available</h1>
      )}
    </>
  );
}
